import { render } from "./VideoComponent.vue?vue&type=template&id=4af8e2a0"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__